import {
  storeSchema,
  type CreateStoreDto,
  type Store,
  type UpdateStoreDto,
} from '@mrrmlab/shared-types';
import { z } from 'zod';
import type { HttpClient } from './http';

const storesArraySchema = z.array(storeSchema);

export class StoresResource {
  constructor(private readonly http: HttpClient) {}

  list(signal?: AbortSignal): Promise<Store[]> {
    return this.http.request({
      method: 'GET',
      path: '/stores',
      responseSchema: storesArraySchema,
      signal,
    });
  }

  create(dto: CreateStoreDto, signal?: AbortSignal): Promise<Store> {
    return this.http.request({
      method: 'POST',
      path: '/stores',
      body: dto,
      responseSchema: storeSchema,
      signal,
    });
  }

  update(id: string, dto: UpdateStoreDto, signal?: AbortSignal): Promise<Store> {
    return this.http.request({
      method: 'PATCH',
      path: `/stores/${encodeURIComponent(id)}`,
      body: dto,
      responseSchema: storeSchema,
      signal,
    });
  }

  delete(id: string, signal?: AbortSignal): Promise<void> {
    return this.http.request({
      method: 'DELETE',
      path: `/stores/${encodeURIComponent(id)}`,
      expectEmpty: true,
      signal,
    });
  }
}
